<template>
	<!-- Common report filter (spec §7 PosBills): ช่วงวันที่ (≤ 92 วัน), งาน
	     (incl. ชุดเริ่มต้นของเครื่อง = 0), เครื่อง, รวมเครื่องทดสอบ. -->
	<div class="pos-filter row align-items-end">
		<div class="col-md-4 col-12 mb-2">
			<label class="form-control-label d-block">{{ $t("pos.filter.range") }}</label>
			<el-date-picker
				v-model="local.range"
				type="daterange"
				value-format="yyyy-MM-dd"
				format="dd/MM/yyyy"
				:clearable="false"
				:range-separator="'–'"
				class="w-100"
				@change="emit"
			></el-date-picker>
			<small v-if="rangeError" class="text-danger">{{ $t(rangeError) }}</small>
		</div>
		<div class="col-md-3 col-6 mb-2">
			<label class="form-control-label d-block">{{ $t("pos.filter.event") }}</label>
			<el-select v-model="local.eventId" class="w-100" filterable @change="emit">
				<el-option :label="$t('pos.filter.event_all')" value=""></el-option>
				<el-option :label="$t('pos.filter.event_default')" :value="0"></el-option>
				<el-option v-for="e in events" :key="e.id" :label="e.name" :value="e.id"></el-option>
			</el-select>
		</div>
		<div class="col-md-2 col-6 mb-2">
			<label class="form-control-label d-block">{{ $t("pos.filter.device") }}</label>
			<el-select v-model="local.deviceId" class="w-100" filterable @change="emit">
				<el-option :label="$t('pos.filter.device_all')" value=""></el-option>
				<el-option v-for="d in devices" :key="d.id" :label="d.code + ' ' + d.name" :value="d.id"></el-option>
			</el-select>
		</div>
		<div class="col-md-3 col-12 mb-2 d-flex align-items-center flex-wrap">
			<el-checkbox v-model="local.includeTest" class="mr-3" @change="emit">{{ $t("pos.filter.include_test") }}</el-checkbox>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { DatePicker, Select, Option, Checkbox } from "element-ui";
import { posValidateRange } from "@/utils/pos";

export default {
	name: "PosReportFilter",
	components: {
		[DatePicker.name]: DatePicker,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox
	},
	props: {
		value: { type: Object, required: true }
	},
	data() {
		return { local: { ...this.value } };
	},
	computed: {
		devices() {
			return this.$store.getters["Pos/devices"] || [];
		},
		events() {
			return this.$store.getters["Pos/events"] || [];
		},
		rangeError() {
			const r = this.local.range || [];
			return posValidateRange(r[0], r[1]);
		}
	},
	watch: {
		value(v) {
			this.local = { ...v };
		}
	},
	mounted() {
		this.$store.dispatch("Pos/fetchLookups").catch(() => {});
	},
	methods: {
		emit() {
			this.$emit("input", { ...this.local });
			if (!this.rangeError) this.$emit("search", { ...this.local });
		}
	}
};
</script>
